<template>
  <div class="order-container">
    <el-card>
      <div slot="header">
        <span>激活码录入</span>
      </div>
      <el-tabs value="first" type="border-card">
        <el-tab-pane label="单条录入" name="first">
          <el-form :model="singleForm" :rules="singleRules" ref="singleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="课程名称" prop="ccoursename">
              <el-input v-model="singleForm.ccoursename"></el-input>
            </el-form-item>
            <el-form-item label="激活码" prop="code">
              <el-input v-model="singleForm.code"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('singleForm')">立即创建</el-button>
              <el-button @click="resetForm('singleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="批量录入" name="second">
          <el-form label-width="100px">
            <el-form-item label="数据格式">
              <div class="format-help">
                <p>请按照以下格式输入数据，每行一条激活码信息：</p>
                <p><strong>课程名 激活码</strong></p>
                <p>例如：</p>
                <p>2026考研数学 XXXXXX</p>
                <p>2026考研英语 XXXXXX</p>
                <p>2026考研政治 XXXXXX</p>
              </div>
            </el-form-item>
            <el-form-item label="激活码数据">
              <el-input
                v-model="batchText"
                type="textarea"
                :rows="10"
                placeholder="请按照格式输入激活码数据，每行一条记录"
                style="width: 100%"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleBatchParse">解析数据</el-button>
              <el-button @click="parseBatchData">录入解析结果</el-button>
              <el-button @click="clearBatchData">清空</el-button>
            </el-form-item>
          </el-form>
          
          <!-- 解析结果预览 -->
          <div v-if="parsedData.length > 0" class="parsed-result">
            <h4>解析结果预览 ({{ parsedData.length }} 条记录)</h4>
            <el-table :data="parsedData" style="width: 100%" border>
              <el-table-column prop="ccoursename" label="课程名"></el-table-column>
              <el-table-column prop="code" label="激活码"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" @click="removeParsedItem(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="文件录入" name="third">
          
        </el-tab-pane> -->
      </el-tabs>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'Orders',
  data() {
    return {
      loading: false,
      singleForm: {
        ccoursename: '',
        code: '',
        courseid: ''
      },
      // 表单验证规则
      singleRules: {
        ccoursename: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入激活码', trigger: 'blur' },
        ]
      },
      // 批量录入相关
      batchText: '',
      parsedData: [],
      // 表单验证规则
      formRules: {
        ccoursename: [
          { required: true, message: '请输入课程名', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入激活码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.get_course_list();
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.get_course_list();
      this.$refs[formName].validate(async valid => {
        if (!valid) return
        const found = this.course_list.find(course => course.coursename === this.singleForm.ccoursename);
        if (!found) {
          this.$message.error(`${this.singleForm.ccoursename}对应课程不存在`);
          
          return
        } 
  
        this.singleForm.courseid = found.courseid;
        try {
          const {data: res}= await this.$http.post('create_code',  {
          codes: this.singleForm
        });
          if (res.code == 200){
            this.$message.success('激活码录入成功')
            this.$refs[formName].resetFields();
          } else{
            this.$message.error('激活码录入失败')
          }
        } catch (error) {
          this.$message.error('激活码录入失败')
        }
      })
    },
    async get_course_list() {
      try {
        const {data: res} = await this.$http.get('get_all_course_list');
        if (res.code == 200){
          this.course_list = res.data;
        } else {
          this.$message.error('获取课程列表失败' + res.errmsg);
        }
      } catch (error) {
        this.$message.error('获取课程列表失败');
        console.error('获取课程列表失败:', error);
      }
    },
    // 批量解析数据
    handleBatchParse() {
      if (!this.batchText.trim()) {
        this.$message.warning('请输入激活码数据');
        return;
      }
      this.get_course_list();
      const lines = this.batchText.split('\n').filter(line => line.trim());
      const parsed = [];
      const errors = [];
      
      lines.forEach((line, index) => {
        const parts = line.split(' ').map(part => part.trim());
        
        if (parts.length !== 2) {
          errors.push(`第${index + 1}行格式错误: ${line}`);
          return;
        }
        
        const [ccoursename, code] = parts;
        
        if (!ccoursename) {
          errors.push(`第${index + 1}行课程名为空: ${line}`);
          return;
        }
        
        if (!code) {
          errors.push(`第${index + 1}行激活码为空: ${line}`);
          return;
        }

        const found = this.course_list.find(course => course.coursename === ccoursename);
        if (!found) {
          errors.push(`第${index + 1}行对应课程不存在: ${line}`);
          return;
        }
        const courseid = found.courseid;
        
        parsed.push({
          ccoursename,
          code,
          courseid
        });
      });
      
      // 显示错误信息
      if (errors.length > 0) {
        this.$message.error(`解析发现 ${errors.length} 个错误：\n${errors.join('\n')}`);
      }
      
      this.parsedData = parsed;
      
      if (parsed.length > 0) {
        this.$message.success(`成功解析 ${parsed.length} 条激活码数据`);
      }
    },
    
    // 录入解析结果
    async parseBatchData() {
      if (this.parsedData.length === 0) {
        this.$message.warning('请先解析数据');
        return;
      }
      
      try {
        // 这里替换为实际的批量API调用
        console.log('批量提交激活码:', this.parsedData);
        const {data: res} = await this.$http.post('create_code', {
          codes: this.parsedData
        });
        if (res.code == 200){
          this.$message.success(`成功录入 ${this.parsedData.length} 条激活码`);
          this.clearBatchData();
        } else {
          this.$message.error('批量录入失败' + res.errmsg);
        }
      } catch (error) {
        this.$message.error('批量录入失败');
        console.error('批量录入错误:', error);
      }
    },
    
    // 删除解析结果中的某一项
    removeParsedItem(index) {
      this.parsedData.splice(index, 1);
    },
    
    // 清空批量数据
    clearBatchData() {
      this.batchText = '';
      this.parsedData = [];
    }
  }
}
</script>

<style lang="less">
.order-container {
  padding: 20px;
}

.password_show {
  .el-input__inner {
    border: none;
    background-color: rgba(255, 255, 255, 0);
  }
}
</style>